import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_PUBLISHABLE_KEY in .env'
  );
}

// Reject legacy JWT anon/service keys (eyJ...). Supabase has disabled them.
if (
  supabaseKey.startsWith('eyJ') ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.SUPABASE_ANON_KEY
) {
  throw new Error(
    'Legacy Supabase JWT/anon keys are not allowed. Use REACT_APP_SUPABASE_PUBLISHABLE_KEY only.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
